import {Alert, Button, Checkbox, DatePicker, Form, Input, Modal, Radio, TimePicker} from 'antd';
import React, { useEffect, useState } from 'react';
import { formatPrice } from '../../../../utils/format';
import './TicketModal.scss';
import {CalendarOutlined} from "@ant-design/icons";
import ptBR from "antd/lib/locale/pt_BR";
import moment from "moment/moment";
import dayjs from "dayjs";

const TicketModal = ({ visible, onClose, eventID, isEditing, editingTicket, setTickets, tickets, editingTicketId, setIsModalVisible }) => {
  const [form] = Form.useForm();

  const [nameTicket, setNameTicket] = useState('');
  const [descriptionTicket, setDescriptionTicket] = useState('');
  const [quantity, setQuantity] = useState('');
  const [isFree, setIsFree] = useState(false);
  const [salesPeriodType, setSalesPeriodType] = useState('ALWAYS'); // PERIOD or ALWAYS
  const [internalAmount, setInternalAmount] = useState(0);
  const [errors, setErrors] = useState({});

  const dateFormat = "DD/MM/YYYY";
  const timeFormat = 'HH:mm';
  moment.locale("pt-br");
  // input handling

  useEffect(() => {
    if (editingTicket) {
      setNameTicket(editingTicket.name);
      setDescriptionTicket(editingTicket.description);
      setInternalAmount(editingTicket.amount);
      setQuantity(editingTicket.quantity);
      setSalesPeriodType(editingTicket.sales_period_type || "ALWAYS");

      const startDate = new Date(editingTicket.sales_starts_at);
      const endDate = new Date(editingTicket.sales_ends_at);

      if (editingTicket.amount === 0) {
        setIsFree(true);
      }

      form.setFieldsValue({
        name: editingTicket.name,
        description: editingTicket.description,
        salesPeriodType: editingTicket.sales_period_type || "ALWAYS",
        quantity: editingTicket.quantity,
        startDate: editingTicket.sales_starts_at ? dayjs(editingTicket.sales_starts_at) : null,
        endDate: editingTicket.sales_ends_at ? dayjs(editingTicket.sales_ends_at) : null,
        start: {
          date: dayjs(startDate),
          time: dayjs(startDate).set('hour', startDate.getHours()).set('minute', startDate.getMinutes())
        },
        end: {
          date: dayjs(endDate),
          time: dayjs(endDate).set('hour', endDate.getHours()).set('minute', endDate.getMinutes())
        }
      });
    }
  }, [editingTicket]);

  const handleSave = async () => {
    await handleSaveTicket();
    onClose();
  };

  const handleFreeChange = (e) => {
    setIsFree(e.target.checked);
    if (e.target.checked) {
      setInternalAmount(0);
    }
  };

  const handleSaveTicket = async () => {
    if (await validateFields()) {
      let startDate = null;
      let endDate = null;
      if (salesPeriodType === 'PERIOD') {
        startDate = form.getFieldValue(["start", "date"]).format('YYYY-MM-DD') + 'T' + form.getFieldValue(["start", "time"]).format('HH:mm')
        endDate = form.getFieldValue(["end", "date"]).format('YYYY-MM-DD') + 'T' + form.getFieldValue(["end", "time"]).format('HH:mm')
      }
      if (isEditing) {
        const updatedTickets = tickets.map((ticket) => {
          if (ticket.id === editingTicketId) {
            return {
              ...ticket,
              name: nameTicket,
              description: descriptionTicket,
              amount: internalAmount,
              starterQuestionList: ticket.starterQuestionList || [],
              questions: ticket.questions || [],
              quantity: quantity,
              sales_period_type: salesPeriodType,
              sales_starts_at: startDate,
              sales_ends_at: endDate,
            };
          }
          return ticket;
        });
        setTickets(updatedTickets);
      } else {
        let updatedTickets = [
          ...tickets,
          {
            id: new Date().getTime(),
            name: nameTicket,
            description: descriptionTicket,
            amount: internalAmount,
            questions: [],
            starterQuestionList: [],
            quantity: quantity,
            sales_period_type: salesPeriodType,
            sales_starts_at: startDate,
            sales_ends_at: endDate,
            new: true,
          },
        ]
        setTickets(updatedTickets);
      }

      resetForm();
      setIsModalVisible(false);
    }
  };


  const resetForm = () => {
    setNameTicket("");
    setDescriptionTicket("");
    setInternalAmount(0);
    setIsFree(false)
    form.resetFields();
  };


  const handleAmountChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/[^0-9]/g, '');
    setInternalAmount(parseInt(numericValue, 10) || 0);
  };

  const validateFields = async () => {
    try {
      await form.validateFields();
    } catch (error) {
      return false;
    }
    const newErrors = {
      name: '',
      description: '',
      amount: ''
    };

    if (!nameTicket) newErrors.name = 'Por favor, insira o título do ingresso!';
    if (!descriptionTicket) newErrors.description = 'Por favor, insira a descrição do ingresso!';
    if (!isFree && internalAmount <= 0) newErrors.amount = 'Por favor, insira um preço valor!';
    if (nameTicket.length > 45) newErrors.name = 'O título do ingresso deve ter no máximo 45 caracteres!';
    if (nameTicket.length < 3) newErrors.name = 'O título do ingresso deve ter no mínimo 3 caracteres!';

    setErrors(newErrors);

    return !newErrors.name && !newErrors.description && !newErrors.amount;
  };


  return (
    <div style={{ backgroundColor: "red" }} className="ticket">
      <Modal
        className="ticket-modal"
        title={isEditing ? "Editar ingresso" : "Criar ingresso"}
        visible={visible}
        onOk={handleSave}
        onCancel={() => {
          onClose()
          resetForm()
        }}
        okText={isEditing ? "Salvar" : "Criar ingresso"}
        cancelText="Cancelar"
        footer={[
          <Button className='button-modal' key="cancel" danger onClick={() => {
            onClose()
            resetForm()
          }}>
            Cancelar
          </Button>,
          <Button className='button-modal' key="submit" type="primary" onClick={() => handleSaveTicket()} >
            {isEditing ? "Salvar" : "Criar ingresso"}
          </Button>
        ]}
      >
        <Alert
          className="service-fee"
          message="A taxa de serviço é adicionada ao total e apresentada ao comprador junto com o preço do ingresso"
          banner
          closable
        />

        {/* Formulário */}
        <Form form={form} layout="vertical" className='form-modal'>
          {/* Nome do ingresso */}
          <div className="distribution-three">
            <Form.Item
              hasFeedback={true}
              name="name"
              label="Título do Ingresso"
              validateDebounce={650}
              className="required"
              rules={[{ max: 45 }, { min: 3 }, { required: true }]}
            >
              <Input
                value={nameTicket}
                onChange={(e) => setNameTicket(e.target.value)}
              />

            </Form.Item>
            <Form.Item
              hasFeedback={true}
              name="quantity"
              label="Quantidade"
              validateDebounce={650}
              className="required"
              rules={[
                { required: true, message: "Informe a quantidade!" },
                {
                  validator: (_, value) => {
                    if (isNaN(value) || parseInt(value) <= 0) {
                      return Promise.reject(new Error('A quantidade deve ser um número positivo!'));
                    }
                    return Promise.resolve();
                  }
                }
                ]}
              >
                <Input
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />

            </Form.Item>

            {/* Preço */}
            <div className="small-form">
              <Form.Item
                validateStatus={errors.amount ? 'error' : ''}
                help={errors.amount}
                style={{ margin: 0 }}
                className="required"
                label="Preço">
                <Input
                  value={formatPrice(internalAmount / 100)}
                  onChange={handleAmountChange}
                  disabled={isFree}
                />
              </Form.Item>
              <Checkbox style={{ margin: "10px 0 20px 0" }} checked={isFree} onChange={handleFreeChange}>
                Gratuito
              </Checkbox>
            </div>
          </div>

          <Form.Item
            label="Período de vendas"
            name="salesPeriodType"
          >
            <Radio.Group
              value={salesPeriodType}
              onChange={(e) => {
                setSalesPeriodType(e.target.value);
              }}
            >
              <Radio value="ALWAYS"> Sem data-limite </Radio>
              <Radio value="PERIOD"> Período customizado </Radio>
            </Radio.Group>
          </Form.Item>

          {/* Período de vendas */}
          {salesPeriodType === 'PERIOD' && (
          <>
            <div className="event-form-row date-time-pickers">
              <div className="date-time-group">
                <Form.Item
                  label="Início das Vendas"
                >
                  <div className="date-time-field">
                    <CalendarOutlined className="custom-icon" />
                    <Form.Item name={["start", "date"]} noStyle
                       rules={[{ required: true, message: 'Por favor, insira uma data de início' }]}
                       hasFeedback={true}
                    >
                      <DatePicker
                        format={{ format: dateFormat, type: 'mask' }}
                        placeholder="Data"
                        locale={ptBR}
                        needConfirm={false}
                      />
                    </Form.Item>
                    <Form.Item name={["start", "time"]} noStyle
                       rules={[{ required: true, message: 'Por favor, insira uma hora de início' }]}
                       hasFeedback={true}
                    >
                      <TimePicker
                        use12Hours={false}
                        format={{ format: timeFormat, type: 'mask' }}
                        placeholder="Horário"
                        locale={ptBR}
                        needConfirm={false}
                      />
                    </Form.Item>
                  </div>
                </Form.Item>
              </div>
              <div className="date-time-group">
                <Form.Item
                  label="Término das Vendas"
                >
                  <div className="date-time-field">
                    <CalendarOutlined className="custom-icon" />

                    <Form.Item name={["end", "date"]} noStyle
                       rules={[{ required: true, message: 'Por favor, insira uma data de fim' }]}
                       hasFeedback={true}
                    >
                      <DatePicker
                        format={{ format: dateFormat, type: 'mask' }}
                        placeholder="Data"
                        locale={ptBR}
                        needConfirm={false}
                      />
                    </Form.Item>

                    <Form.Item name={["end", "time"]} noStyle
                       rules={[{ required: true, message: 'Por favor, insira uma hora de fim' }]}
                       hasFeedback={true}
                    >
                      <TimePicker
                        use12Hours={false}
                        format={{ format: timeFormat, type: 'mask' }}
                        placeholder="Horário"
                        locale={ptBR}
                        needConfirm={false}
                      />
                    </Form.Item>
                  </div>
                </Form.Item>
              </div>
            </div>
          </>
            )}

          {/* Descrição */}
          <div className="textarea-form">
            <Form.Item
              hasFeedback={true}
              name="description"
              validateDebounce={650}
              label="Descrição do Ingresso"
              className="required"
              rules={[{ max: 450 }, { min: 3 }, { required: true }]}
            >
              <Input.TextArea
                value={descriptionTicket}
                onChange={(e) => setDescriptionTicket(e.target.value)}

              />
            </Form.Item>
          </div>
        </Form>

      </Modal>
    </div>
  );
};

export default TicketModal;
